import VerifyPinRequest from '../entities/VerifyPinRequest'
import VerifyPinResponse from '../entities/VerifyPinResponse'
import { IUserRepository } from '../repositories/IUserRepository'

export interface IVerifyPin {
  execute(params: VerifyPinRequest): Promise<VerifyPinResponse>
}

export default class VerifyPinImpl implements IVerifyPin {
  constructor(private readonly userRepository: IUserRepository) {}

  public async execute(params: VerifyPinRequest): Promise<VerifyPinResponse> {
    const response = await this.userRepository.verifyPin(params)

    return response
  }
}
